import { Injectable } from '@angular/core';
import { UserService } from './api/user.service';
import { MunicipalityService } from './api/municipality.service';
import { mergeMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class KamService {
  constructor(private userApi: UserService, private municipalityApi: MunicipalityService) {}

  public getByMunicipalityId(municipalityId: string): Observable<User | null> {
    return this.municipalityApi.getByMunicipalityGuid(municipalityId).pipe(
      mergeMap((m: any[]) => {
        if (m && m.length > 0 && m[0].primaryAdminGuid) {
          return this.userApi.getByUserGuid(m[0].primaryAdminGuid);
        }
        return of(null);
      })
    );
  }

  public getByMunicipalityIdDirect(municipalityId: string): Observable<User | null> {
    return this.municipalityApi.getKamByMunicipalityGuid(municipalityId);
  }
}
